'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Lockup from 'components/blocks/shared/Lockup';
import Slideshow from 'components/ui/Slideshow';
import Text from 'components/ui/Text';

import { blockRootProps } from 'utils';

import styles from './BlockTwoColumnCarousel.module.scss';

const lockupHeadlineOverrides = {
    recipeDetail: {
        baseTheme: 'headingMedium',
        themes: { large: 'headingXLarge' },
    },
};

const BlockTwoColumnCarousel = ({
    __typename,
    eyebrow,
    headline,
    copy,
    images,
    cta,
    firstBlock,
    lastBlock,
    flushTop,
    flushBottom,
    imageOnLeft,
    children,
    theme,
    colorTheme,
    anchorId,
}) => {
    theme ??= 'default';

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.root, styles[theme], {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
                [styles.lastBlock]: lastBlock,
                [styles.imageOnLeft]: imageOnLeft,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.column}>
                    <Slideshow
                        firstBlock={firstBlock}
                        images={images}
                        theme={colorTheme?.toLowerCase()}
                    />
                </div>
                <div className={styles.column}>
                    <div className={styles.lockup}>
                        <Lockup
                            eyebrow={{ text: eyebrow }}
                            headline={{
                                as: firstBlock ? 'h1' : 'h2',
                                text: headline,
                                themeOverrides: lockupHeadlineOverrides[theme],
                            }}
                            copy={{ text: copy }}
                            ctas={cta}
                            theme="Small"
                        />
                        {children && (
                            <Text
                                as="div"
                                className={styles.children}
                                baseTheme="bodySmall"
                                themes={{
                                    large: 'bodyLarge',
                                }}
                                fixWidows
                            >
                                {children}
                            </Text>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

BlockTwoColumnCarousel.propTypes = {
    __typename: PropTypes.string,
    children: PropTypes.node,
    copy: PropTypes.string,
    cta: PropTypes.object,
    eyebrow: PropTypes.string,
    flushBottom: PropTypes.bool,
    flushTop: PropTypes.bool,
    headline: PropTypes.string,
    headlineTag: PropTypes.string,
    imageOnLeft: PropTypes.bool,
    images: PropTypes.array,
    lastBlock: PropTypes.bool,
    theme: PropTypes.string,
    colorTheme: PropTypes.string,
};

export default BlockTwoColumnCarousel;
